import React, {Component} from 'react';
import Navigation from '../Navigation';
import { Container } from 'react-bootstrap';
import { withRouter, Redirect } from 'react-router-dom';

class Logout extends Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      isLoggingOut: false,
    };
  }

  componentDidMount() {
    const { auth } = this.props;
    this.setState({
      isLoggingOut: true
    });
    auth.logout();
  }

  render() {
    const { isLoggingOut } = this.state;

    if (isLoggingOut) {
      return <Redirect to="/" push={true} />
    }

    let message = 'Logging out ...';
    return (
      <div>
        <Navigation showDashboardOptions={false} {...this.props} />
        <Container className="dashboard_container">
          <h2 className="text-center">{message}</h2>
        </Container>
      </div>
    );
  }
}

export default withRouter(Logout);
